import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Inject, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatRadioModule } from '@angular/material/radio';
import { I18NextModule } from 'angular-i18next';
import { WrongdoingKind } from 'src/types/graphql';
import { BaseComponent } from '../../components/base/base.component';
import { GenericDialogComponent } from '../generic-dialog/generic-dialog.component';
import { LoadingComponent } from '../../components/loading/loading.component';
import { BlockContentGQL, WrongdoingReportCreateGQL } from './report-dialog.mutation.generated';

@Component({
  selector: 'sharry-report-dialog',
  standalone: true,
  imports: [
    I18NextModule,
    MatRadioModule,
    FormsModule,
    MatFormFieldModule,
    LoadingComponent,
    GenericDialogComponent,
    MatInputModule,
    MatCheckboxModule,
  ],
  templateUrl: './report-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ReportDialogComponent extends BaseComponent implements OnInit {
  selectedOption: WrongdoingKind;
  title = 'report-dialog.title';
  options = Object.values(WrongdoingKind);
  text = '';
  confirmationTitle = '';
  confirmationTextTop = '';
  confirmationTextBottom = '';
  step: 'option' | 'text' | 'confirmation' = 'option';
  busy = false;
  blockContent = false;
  showBlock = false;

  constructor(
    private dialogRef: MatDialogRef<ReportDialogComponent>,
    @Inject(MAT_DIALOG_DATA) private data: any,
    private wrongdoingReportCreateGQL: WrongdoingReportCreateGQL,
    private cd: ChangeDetectorRef,
    private blockContentGQL: BlockContentGQL,
  ) {
    super();
    if (data.isCreate) {
      this.title = 'report-dialog.title--help';
      this.options = [WrongdoingKind.NotCorrect, WrongdoingKind.Other];
      this.confirmationTextTop = 'report-dialog.confirmation-text-top--help';
      this.confirmationTextBottom = 'report-dialog.confirmation-text-bottom--help';
      this.confirmationTitle = 'report-dialog.report-sent--help';
    } else if (data.isSharryManagement) {
      this.title = 'report-dialog.title--help';
      this.options = [
        WrongdoingKind.NeedInformations,
        WrongdoingKind.ContentChange,
        WrongdoingKind.RequestComplete,
        WrongdoingKind.Other,
      ];
      this.confirmationTextTop = 'report-dialog.confirmation-text-top--help';
      this.confirmationTextBottom = 'report-dialog.confirmation-text-bottom--help';
      this.confirmationTitle = 'report-dialog.report-sent--help';
    } else if (data.isPlaceUtility) {
      this.title = 'report-dialog.title--help';
      this.options = [WrongdoingKind.NotCorrect, WrongdoingKind.NewContent];
      this.confirmationTextTop = 'report-dialog.confirmation-text-top--help';
      this.confirmationTextBottom = 'report-dialog.confirmation-text-bottom--help';
      this.confirmationTitle = 'report-dialog.report-sent--help';
    } else {
      this.title = 'report-dialog.title';
      this.options = [
        WrongdoingKind.NotCorrect,
        WrongdoingKind.CopyrightInfringement,
        WrongdoingKind.InappropriateContent,
        WrongdoingKind.BadBehaviour,
        WrongdoingKind.IdentityTheft,
        WrongdoingKind.Other,
      ];
      this.confirmationTextTop = 'report-dialog.confirmation-text-top';
      this.confirmationTextBottom = 'report-dialog.confirmation-text-bottom';
      this.confirmationTitle = 'report-dialog.report-sent';
    }
    this.showBlock = !!data.showBlock;
  }

  ngOnInit() {
    this.cd.detectChanges();
  }

  backStep() {
    this.step = 'option';
  }

  nextStep() {
    switch (this.step) {
      case 'option':
        this.step = 'text';
        this.cd.detectChanges();
        break;
      case 'text':
        this.submit();
        break;
      case 'confirmation':
        this.dialogRef.close(this.blockContent);
        break;
    }
  }

  submit() {
    this.busy = true;
    this.cd.detectChanges();
    this.subscriptions.push(
      this.wrongdoingReportCreateGQL
        .mutate({
          input: {
            reportedEntityId: this.data.reportedEntityId,
            reportedEntityType: this.data.reportedEntityType,
            kind: this.selectedOption,
            body: this.text,
          },
        })
        .subscribe(_ => {
          this.step = 'confirmation';
          this.busy = false;
          if (this.blockContent) this.onBlockContent();
          this.cd.detectChanges();
        }),
    );
  }

  onBlockContent() {
    this.subscriptions.push(
      this.blockContentGQL
        .mutate({
          input: {
            contentId: this.data.reportedEntityId,
            contentType: this.data.reportedEntityType,
          },
        })
        .subscribe(),
    );
  }

  close() {
    this.dialogRef.close(this.step === 'confirmation' ? this.blockContent : undefined);
  }
}
